import { jsx as _jsx } from "react/jsx-runtime";
import CmsBreadcrumb from '@helsenorge/core-cms/breadcrumb';
import { getTjenesterUrl } from '@helsenorge/framework-utils/hn-proxy-service';
import { Projects, useResources } from '../resources';
import styles from './styles.module.scss';
const Breadcrumb = props => {
    const resources = useResources(Projects.FRAMEWORK);
    const linkText = props.children || resources?.breadCrumb_Forsiden;
    const href = props.href || getTjenesterUrl();
    const ariaLabel = resources?.breadcrumb_arialabel;
    if (linkText && href && ariaLabel) {
        return (_jsx("div", { className: styles.breadcrumb, children: _jsx(CmsBreadcrumb, { href: href, ariaLabel: ariaLabel, renderAsRouterLink: props.renderAsRouterLink, children: linkText }) }));
    }
    return null;
};
export default Breadcrumb;
